<template>
  <anchor-modal
    light
    eager
    width="500"
    header-color="white"
    :header-split="true"
    title="Change Password"
    :loading="loading"
    v-model="display"
  >
    <reset-password-form
      ref="resetPasswordForm"
      :user="user"
      :requireOldPass="true"
      :tip="tip"
      @submit="submit"
    />
    <div class="d-flex mb-4">
      <v-spacer />
      <v-btn
        id="reset-pwd-form-cancel-btn"
        @click="() => display = false"
      >
        Cancel
      </v-btn>
      <v-btn
        id="reset-pwd-form-save-btn"
        color="primary"
        class="ml-3"
        :disabled="submitDisabled"
        :loading="loading"
        @click="submit"
      >
        Save
      </v-btn>
    </div>
  </anchor-modal>
</template>

<script>
import ResetPasswordForm from './ResetPasswordForm';


export default {
  name: 'AdminUsersForm',
  props: {
    tip: String,
  },
  components: {
    ResetPasswordForm,
  },
  data: () => ({
    display: false,
    loading: false,
  }),
  computed: {
    user: vm => vm.$store.getters.user,
    submitDisabled() {
      if (!this.display) { return true; }
      return this.$refs.resetPasswordForm.submitDisabled;
    },
  },
  methods: {
    open() {
      this.display = true;
    },
    close() {
      this.display = false;
    },
    submit() {
      const formRef = this.$refs.resetPasswordForm;
      if (!formRef.validate()) { return; }

      this.loading = true;
      this.$requests.post('/auth/change-password/', formRef.getModel())
        .then(() => {
          this.$toast.success(`Password for ${this.user.username} updated!`, { timeout: 3000 });
          this.close();
        })
        .catch(err => {
          const message = err.response ?
            err.response.data.message :
            `Unable to update password for ${this.user.username}...`;
          this.$toast.error(message, { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    display(value) {
      if (!value) {
        this.$refs.resetPasswordForm.reset();
      }
    },
  },
};
</script>
